import { FieldPolicy } from '@apollo/client'

export const conversation: FieldPolicy = {
  keyArgs: ['pk'],
}
